import {
  loadWasm
} from "./chunk-ASAKH4TV.js";

// src/index.ts
async function init(opts = {}) {
  await loadWasm(opts);
}
async function detectFormat(input) {
  const bytes = await toBytes(input);
  const wasm = await loadWasm();
  const ext = wasm.detect_format(bytes);
  return {
    format: ext === "" ? null : ext,
    extension: ext || null
  };
}
async function convert(input, opts) {
  const bytes = await toBytes(input);
  const wasm = await loadWasm();
  return wasm.convert(bytes, opts.from ?? "", opts.to);
}
async function convertToString(input, opts) {
  const bytes = await toBytes(input);
  const wasm = await loadWasm();
  return wasm.convert_to_string(bytes, opts.from ?? "", opts.to);
}
async function extractText(input, from) {
  const bytes = await toBytes(input);
  const wasm = await loadWasm();
  return wasm.extract_text(bytes, from ?? "");
}
async function openToModel(input, from) {
  const s = await openToModelString(input, from);
  return JSON.parse(s);
}
async function openToModelString(input, from) {
  const bytes = await toBytes(input);
  const wasm = await loadWasm();
  return wasm.open_to_json_string(bytes, from ?? "");
}
async function convertModel(model, opts) {
  return convertModelString(JSON.stringify(model), opts);
}
async function convertModelString(json, opts) {
  const wasm = await loadWasm();
  return wasm.convert_from_model_string(json, opts.to);
}
async function toBytes(input) {
  if (input instanceof Uint8Array) return input;
  if (input instanceof ArrayBuffer) return new Uint8Array(input);
  if (input instanceof Blob) return new Uint8Array(await input.arrayBuffer());
  throw new Error("Unsupported input \u2014 expected Uint8Array, ArrayBuffer, or Blob.");
}
export {
  convert,
  convertModel,
  convertModelString,
  convertToString,
  detectFormat,
  extractText,
  init,
  openToModel,
  openToModelString
};
